import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/equipment-overdue")({
  component: () => <Outlet />,
});
